<template>
    <Dialog :open="open" :title="$t('subscription.subscriptionDetails')" max-width="900" @close="open = false">
        <v-container class="pa-0">
            <v-form ref="form">
                <v-text-field :label="$t('authentication.subscriptionName')" :value="subscription.Name" disabled
                              readonly/>
                <v-text-field :label="$t('status')"
                              :value="subscriptionDetails ? (subscriptionDetails.IsExpired ? $t('subscription.expired') : $t('user.active')) : ''"
                              disabled
                              readonly/>
                <v-text-field :label="$t('subscription.billingPlan')"
                              :value="subscriptionDetails?subscriptionDetails.SubscriptionName:''" disabled readonly/>
                <v-text-field :label="$t('subscription.renewalDate')"
                              :value="subscriptionDetails?formatDateTime(subscriptionDetails.ExpiryDate):''" disabled
                              readonly/>
                <v-text-field :label="$t('subscription.activeMembersRemaining')"
                              :value="subscriptionDetails?subscriptionDetails.NumberOfMembers+' /'+subscriptionDetails.NumberOfMembersUsed:''"
                              disabled readonly/>
                <v-text-field :label="$t('subscription.SMSVolumeRemaining')"
                              :value="subscriptionDetails?subscriptionDetails.NumberOfSMS+'/'+subscriptionDetails.NumberOfSMSUsed:''"
                              disabled readonly/>
            </v-form>
        </v-container>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";
import {formatDateTime} from "@/helper/helper";
import {
  CHANNEL_EMAIL,
  CHANNEL_REALTIME,
  CHANNEL_SMS,
  NOTIFICATION_COMPLETED,
  NOTIFICATION_FAILED,
  NOTIFICATION_PENDING
} from "@/helper/constants";

export default {
  name: "SubscriptionDetails",
  components: {
    Dialog
  },
  props: {
    subscriptionID: {
      type: Number,
      required: false,
    },
    subscription: {
      type: Object,
      required: true,
    }
  },
  computed: {
    filteredRecipients() {
      return this.recipients.filter((recipient) => this.filters.channels.includes(recipient.Channel) && this.filters.status.includes(recipient.Status));
    },
    header() {
      return [
        {text: this.$t('circles.avatar'), value: 'AvatarUrl'},
        {text: this.$t('authentication.firstName'), value: 'FirstName'},
        {text: this.$t('authentication.lastName'), value: 'LastName'},
        {text: this.$t('authentication.email'), value: 'Email'},
        {text: this.$t('notifications.channel'), value: 'Channel'},
        {text: this.$t('status'), value: 'Status'},
        {text: this.$t('notifications.viewedAt'), value: 'ViewedAt'},
      ];
    },
    channels() {
      return [
        {
          value: CHANNEL_SMS,
          text: this.$t('settings.SMS')
        },
        {
          value: CHANNEL_REALTIME,
          text: this.$t('settings.Realtime')
        },
        {
          value: CHANNEL_EMAIL,
          text: this.$t('settings.Email')
        },
      ];
    },
    statuses() {
      return [
        {
          value: NOTIFICATION_PENDING,
          text: this.$t('notifications.pending')
        },
        {
          value: NOTIFICATION_COMPLETED,
          text: this.$t('notifications.completed')
        },
        {
          value: NOTIFICATION_FAILED,
          text: this.$t('notifications.failed')
        },
      ];
    },
  },
  watch: {
    subscriptionID(id) {
      if (id) {
        this.getSubscriptionDetails(id);
      } else {
        this.subscriptionDetails = null;
      }
    },
  },
  mounted() {
    if (this.subscriptionID) {
      this.getSubscriptionDetails(this.subscriptionID);
    }
  },
  data() {
    return {
      open: false,
      recipients: [],
      loading: false,
      filters: {
        channels: [],
        status: [],
      },
      availableValues: {
        channels: new Set(),
        status: new Set(),
      },
      subscriptionDetails: null
    };
  },
  methods: {
    formatDateTime,
    getSubscriptionDetails(id) {
      const url = this.$store.getters.subscriptionDetails(id);
      this.$store.dispatch('setLoader', true);
      this.axios.get(url).then(({data}) => {
        this.subscriptionDetails = data.Result;
        this.open = true;
      }).finally(() => {
        this.$store.dispatch('setLoader', false);
      });
    }
  }
};
</script>

<style lang="scss" scoped>

</style>